<template>
  <div class="superuser-edit-shipping">
    <div class="superuser-edit-shipping__inputs">
      <div class="input-icon">
        <label for="absolutCost">{{ tStatic('superUserShippingAbsoluteLabel') }}</label>

        <input
          id="absolutCost"
          v-model="absoluteCost"
          type="text"
          class="comment__input">
      </div>

      <div class="input-icon">
        <label for="percentageOff">{{ tStatic('superUserShippingPercentageLabel') }}</label>

        <input
          id="percentageOff"
          v-model="percentageOff"
          type="text"
          class="comment__input">
      </div>
    </div>

    <div class="comment__actions comment__actions--space">
      <button class="comment__action" @click.prevent="setShipping()">
        {{ tStatic('headerCartNoteSaveLabel') }}
      </button>

      <button class="comment__action" @click="emitDoneShipping()">
        {{ tStatic('headerCartNoteCloseLabel') }}
      </button>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import { mapActions } from 'vuex'

export default {
  props: {
    shipping: { type: Object, required: false, default: null }
  },
  data: () => ({
    absoluteCost: null,
    percentageOff: null
  }),
  methods: {
    ...mapActions('commerce', ['setCart']),
    emitDoneShipping() {
      this.$emit('done-shipping')
    },
    setShipping() {
      httpService.post('cart/setShipmentCost', {
        newShipmentCost: {
          absoluteCost: this.absoluteCost !== null ? parseInt(this.absoluteCost) : null,
          percentageOff: this.percentageOff !== null ? parseInt(this.percentageOff) : null
        }
      }).then(({ data }) => {
        this.setCart(data.data)
        this.emitDoneShipping()
      })
      // if (this.validateValue(this.absoluteCost) || this.validateValue(this.percentageOff)) {
      // }
    },
    validateValue(value) {
      return !!((value !== null && parseInt(value) >= 0))
    }
  }
}
</script>

<style lang="scss">
.superuser-edit-shipping {
  margin-top: measure(quarter);
  margin-bottom: measure(half);
}

.superuser-edit-shipping__inputs {
  display: flex;
  flex-direction: column;
  gap: measure(quarter);
  max-width: 14rem;
  margin-bottom: measure(quarter);
  margin-left: auto;
}

.superuser-edit-shipping__currently {
  @include caption;
  margin-bottom: measure(quarter);
  text-align: right;
}

.input-icon {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.input-icon label {
  @include caption;
  margin-bottom: measure(eighth);
}

.input-icon input {
  margin-bottom: 0;
}

.input-icon span {
  margin-left: measure(quarter);
}
</style>
